import { hasContent } from '@/helper/RichText';
import type { RichtextStoryblok } from '@/types/component-types-sb';

/** Whether the calculator story `text` field should render (CMS `hide_footer_text` + embed `hideFooter`). */
export function shouldShowCalculatorStoryFooter(
  text: RichtextStoryblok | undefined,
  options?: { hideFooter?: boolean; hideFooterText?: boolean }
): boolean {
  return hasContent(text) && !options?.hideFooter && !options?.hideFooterText;
}
